import { useContext } from 'react';
import { AssetsContext } from '../../DataShare/NRAssetsDataShare';
import NRTaskProgress from './NRTaskProgress';
import { CONSTANTS } from '../../constants/constants';
import NRTaskIndeterminateProgress from './NRTaskIndeterminateProgress';
import NRHttpDownloadTask from './NRHttpDownloadTask';

function NRTaskProgressContainer() {
  const { tasks } = useContext(AssetsContext);

  return (
    <div>
      {tasks?.map(eachTask => (
        <div key={`${eachTask.id}`}>
          {eachTask.type === CONSTANTS.TASKS.TYPE.DOWNLOAD && <NRTaskIndeterminateProgress task={eachTask} />}
          {eachTask.type === CONSTANTS.TASKS.TYPE.UPLOAD && <NRTaskProgress task={eachTask} tasks={tasks} />}
          {eachTask.type === CONSTANTS.TASKS.TYPE.DOWNLOAD_HTTP_POST && <NRHttpDownloadTask task={eachTask} />}
        </div>
      ))}
    </div>
  );
}

export default NRTaskProgressContainer;
